import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'footer',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    list: {},
    listItem: {},
  }),
  options
);

export default useStyles;
